import type * as React from 'react'

import type {AgentPoolId} from '../../../../../types'
import {renderTitle} from '../../../../common/OverviewTab/OverviewTab'
import {DEFAULT_AGENT_POOL_ID} from '../AgentPoolPage.constants'
import type {AgentPool} from '../AgentPoolPage.types'

export default function ProjectsTabTitle({
  agentPoolId,
  agentPool,
  isSelected,
}: {
  agentPoolId: AgentPoolId
  agentPool: AgentPool | null
  isSelected: boolean
}): React.ReactElement | null {
  if (agentPool?.projects != null) {
    // The Root project is a meta project that should not be taken into account.
    // It's always assigned with the default agent pool, so we should subtract it from the total count.
    const projectsCount = agentPool.projects.count - (agentPoolId === DEFAULT_AGENT_POOL_ID ? 1 : 0)
    return renderTitle('Projects', String(projectsCount))(isSelected)
  }

  return null
}
